<template>
  <div
    class="box"
    :class="{
      'box--rounded': rounded,
      [`box--bg-${backgroundColor}`]: backgroundColor,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    backgroundColor?: string;
    rounded?: boolean;
  }>(),
  {
    backgroundColor: '',
    rounded: false,
  },
);
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  padding: 18px;

  &--rounded {
    border-radius: 5px;
  }

  // Colors
  @each $palette, $tones in $palettes {
    @each $tone, $hex in $tones {
      @if $tone == 'base' {
        &.box--bg-#{$palette} {
          background-color: $hex;
        }
      } @else {
        &.box--bg-#{$palette}-#{$tone} {
          background-color: $hex;
        }
      }
    }
  }
}
</style>
